<template>
  <!-- 時間外管理登録画面 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>予定超過残業の申請作成</h2>
      </CCardHeader>
      <CCardBody>
        <span class="preika-required-note"><span class="preika-required-note__mark" aria-hidden="true">*</span><span>が付いている項目は必須入力項目です</span></span>
        <ValidationObserver ref="obs">
          <CRow>
            <div class="container">
              <table class="table table-borderless preika-report-form">
                <!-- 時間 -->
                <tr>
                  <th scope="row">予定時間外勤務時間<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="12" class="preika-report-field preika-report-field--compact">
                        <ValidationProvider name='予定時間外勤務時間' rules="required|half_width_and_limit_decimal" v-slot="ProviderProps">
                          <CInput class="preika-control-frame--unit" v-model="overtime">
                            <template #append-content>H</template>
                          </CInput>
                          <p class="error">
                            <span class="error">{{ ProviderProps.errors[0] }}</span>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>

                <!-- 理由 -->
                <tr>
                  <th scope="row">発生理由<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="12" class="preika-report-field preika-report-field--wide">
                        <ValidationProvider name='発生理由' rules="required" v-slot="ProviderProps">
                          <CTextarea
                            class="preika-report-reason-input"
                            v-model="reason"
                            rows="4"
                          />
                          <p class="error">
                            <span class="error">{{ ProviderProps.errors[0] }}</span>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>
              </table>
              <CRow class="mt-3 align-items-center">
                <CCol class="text-start">
                  <button class="btn btn-secondary" @click="valueCheck">戻る</button>
                </CCol>
                <CCol class="text-center">
                  <save-button
                    :label="'報告'"
                    :loading="loading"
                    @click="whenValid('obs', apply)"
                    class="btn btn-primary"
                  />
                </CCol>
                <CCol></CCol>
              </CRow>
              <label class="mt-2">※ 保存すると上長向けの報告一覧へ反映されます。自分の申請一覧での申請操作はありません。</label>
            </div>
          </CRow>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>


<script>
import submitWhenValidMixin from '@/mixins/submitWhenValidMixin'
import ConstList from './../../ConstList'
import { requestFailureMessage } from '@/utils/requestFailure'
import axios from 'axios'
import SaveButton from '../../common/SaveButton';
export default {
  mixins: [submitWhenValidMixin],
  components: { SaveButton },
  name: 'RegisterInput',
  data() {
    return {
      overtime: 0,
      reason: '',
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    }
  },

  methods: {
    // 登録内容を送信
    apply: function () {

      //二重サブミット対策
      if (this.submit_flg) return;
      //フラグがfalseならば、フラグをtrueにしたうえでsubmit
      this.submit_flg = true;

          //二重サブミット後の処理
          if (confirm) {
          this.loading = true;
          const params = new URLSearchParams()
          params.append("overtime", this.overtime)
          params.append("reason", this.reason)
          return axios
            .post((process.env.VUE_APP_API_ORIGIN) + '/overtimeRegister', params)
            .then(response => {
              this.submit_flg = false;
              if (response.data === ConstList.SUCCESS) {
                alert(ConstList.REGISTER_MESSAGE)
                this.$router.push({ name: '予定超過残業の申請'})
              } else {
                alert(ConstList.APPLY_ERROR)
              }
            })
            .catch(error => {
              this.submit_flg = false;
              axios
              .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
              .then(() => {
                alert(requestFailureMessage(error));
              })
              .catch(() => {
                alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
              })
            })
            .finally(() => {
              this.loading = false;
            });
          }
    },
    date_min() {
      return ConstList.DATE_MIN;
    },
    date_max() {
      return ConstList.DATE_MAX;
    },
    valueCheck: function () {
      if ((this.overtime != 0) || 
        (this.reason != '')) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({
            name: ConstList.ROUTE_OVERTIMES_LIST,
          })
        }
      } else {
        this.$router.push({
          name: ConstList.ROUTE_OVERTIMES_LIST,
        })
      }
    },
  },
};
  
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

.container {
  margin-left: 0%;
}
</style>
